// QuotePublishedEvent.ts
import type { _quoteEventBaseFactoryParams } from "@@/shared/quotes/quote-events/_quote-base.event";
import {
    _quoteEventBaseFactory,
    _quoteEventBaseZodObject,
} from "@@/shared/quotes/quote-events/_quote-base.event";
import type { Except } from "type-fest";
import { z } from "zod";

const quotePublishedEventZodSchema = _quoteEventBaseZodObject.merge(
    z.object({
        type: z.literal("PUBLISHED"),
        publishedVersion: z.number().int().positive(),
    }),
);

type QuotePublishedEvent = z.infer<typeof quotePublishedEventZodSchema>;

type Params = Except<
    _quoteEventBaseFactoryParams &
        Except<QuotePublishedEvent, "type" | "_id" | "_type" | "_createdAt">,
    "signature"
> & {
    _version?: number;
};

const QuotePublishedEventFactory = (params: Params): QuotePublishedEvent => ({
    ..._quoteEventBaseFactory({
        quoteId: params.quoteId,
        _version: params._version ?? 0,
        providerId: params.providerId,
        providerSlug: params.providerSlug,
        signature: [params.quoteId, "PUBLISHED"],
    }),

    type: "PUBLISHED",
    quoteId: params.quoteId,
    publishedVersion: params.publishedVersion,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isQuotePublishedEvent = (event: any): event is QuotePublishedEvent => {
    return (
        !!event && event._type === "QUOTE_EVENT" && event?.type === "PUBLISHED"
    );
};

export {
    isQuotePublishedEvent,
    QuotePublishedEventFactory,
    quotePublishedEventZodSchema,
};
export type { QuotePublishedEvent };
